var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9987 6.00071H3.13972L6.76939 1.64111C6.93912 1.43691 7.02077 1.17365 6.99639 0.909247C6.97202 0.644844 6.8436 0.400955 6.63941 0.231232C6.43521 0.0615082 6.17195 -0.0201464 5.90755 0.00423112C5.64314 0.0286087 5.39925 0.157022 5.22953 0.36122L0.229979 6.36068C0.196343 6.4084 0.166264 6.45853 0.139987 6.51067C0.139987 6.56066 0.139988 6.59066 0.0699939 6.64066C0.0246714 6.75531 0.000941037 6.87735 0 7.00063C0.000941037 7.1239 0.0246714 7.24594 0.0699939 7.36059C0.0699939 7.41059 0.0699936 7.44059 0.139987 7.49058C0.166264 7.54272 0.196343 7.59285 0.229979 7.64057L5.22953 13.64C5.32354 13.7529 5.44127 13.8437 5.57435 13.9059C5.70742 13.9681 5.85256 14.0002 5.99946 14C6.23309 14.0005 6.45951 13.9191 6.63941 13.77C6.74065 13.6861 6.82435 13.583 6.88569 13.4666C6.94704 13.3503 6.98483 13.223 6.99691 13.0921C7.00898 12.9611 6.9951 12.829 6.95606 12.7034C6.91702 12.5778 6.85359 12.4612 6.76939 12.3601L3.13972 8.00054H14.9987C15.2638 8.00054 15.5182 7.89519 15.7057 7.70767C15.8932 7.52015 15.9986 7.26582 15.9986 7.00063C15.9986 6.73543 15.8932 6.4811 15.7057 6.29358C15.5182 6.10606 15.2638 6.00071 14.9987 6.00071Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightVector);
export default __webpack_public_path__ + "static/media/rightVector.b6aba527adfd7511372d8427c9530ca2.svg";
export { ForwardRef as ReactComponent };